module.exports = __webpack_public_path__ + "static/media/FL_BNoble_en.cc618e4b.png";